module.exports = __webpack_public_path__ + "media/images/landings/promotion_2/line_flow_img_sp-ca6ffbc0cdaaba1043b3daf17ed0d99f.png";